/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Link } from 'react-router-dom-v5-compat'
import { useDeviceMediaQuery } from '../UseDeviceMediaQuery/useDeviceMediaQuery'

const UltyLinkLabel = ({ to, active, label, children, ...props }) => {
    const {isMobile} = useDeviceMediaQuery()

    return (
      <Link
        className={props.className}
        css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: .5rem;
            color: unset;
            padding: .8rem;
            background-color: transparent;
            -webkit-tap-highlight-color: transparent;

            ${isMobile && `
                border: 1px solid lightgrey;
                border-radius: 3px;
            `}
            ${active && `
                    border-bottom: 2px solid black;
                    font-weight: 700;
                `}
            :hover {
                color: unset;
                ${active && `
                    border-bottom: 2px solid black;
                `}
            }
        `}
        to={to}
      >
          {label ? label : children}
      </Link>
    )
}

export { UltyLinkLabel }
